module.exports = __webpack_public_path__ + "img/Counter Icon 3@2x.e04784b9.png";